var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        id: "bodyBox",
        title: "收货地址",
        visible: _vm.visible,
        width: "90%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("ul", [
        _c("li", [_vm._v("1")]),
        _c("li", [_vm._v("2")]),
        _c("li", [_vm._v("3")]),
        _c("li", [_vm._v("4")]),
        _c("li", [_vm._v("5")]),
      ]),
      _c(
        "el-form",
        { attrs: { model: _vm.form } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "活动名称", "label-width": "120px" } },
            [
              _c("el-input", {
                attrs: { autocomplete: "off" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动区域", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择活动区域" },
                  model: {
                    value: _vm.form.region,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "region", $$v)
                    },
                    expression: "form.region",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "区域一", value: "shanghai" },
                  }),
                  _c("el-option", {
                    attrs: { label: "区域二", value: "beijing" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }